import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Menu, Row, Col, Tag, Carousel, Image, Statistic } from "antd";
import {
  AppstoreOutlined,
  BarChartOutlined,
  CloudOutlined,
  ShopOutlined,
  TeamOutlined,
  UserOutlined,
  VideoCameraOutlined,
  YoutubeOutlined,
  FacebookOutlined,
  SendOutlined,
  InstagramOutlined,
  LikeOutlined,
  // eslint-disable-next-line
  UploadOutlined,
  // eslint-disable-next-line
  TwitterOutlined,
  // eslint-disable-next-line
  LinkedinOutlined,
} from "@ant-design/icons";
import { Typography } from "antd";
import { tipos } from "../types/tipos";
import StarNo from "../svgs/star_no.svg";
import Star from "../svgs/star.svg";
import Wsp from "../svgs/whatsapp.svg";

// eslint-disable-next-line
const { Title, Paragraph, Text, Link } = Typography;
const { Header, Content, Sider } = Layout;

export const Inicio = () => {
  const [animFace, setAnimFace] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const dispatch = useDispatch();
  // eslint-disable-next-line
  const { appName, marginLeft, marginTop, marginBottom, textColor } = useSelector((state) => state.ui);

  const onCollapse = (collapsed) => {
    collapsed ? dispatch({ type: tipos.setAll, payload: { marginLeft: 80 } }) : dispatch({ type: tipos.setAll, payload: { marginLeft: 200 } });
    setCollapsed(collapsed);
  };

  const contentStyle = {
    width: "100%",
    color: "#fff",
    height: "220px",
    lineHeight: "200px",
    textAlign: "center",
    background: "#364d79",
  };

  return (
    <Layout style={{ backgroundColor: "#252525", height: `calc(100% - ${marginBottom}px)` }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          marginTop,
          zIndex: 0,
          left: 0,
        }}
      >
        <Menu theme="dark" mode="inline" defaultSelectedKeys={["7"]}>
          <Menu.Item key="1" icon={<UserOutlined />} disabled>
            Perfil
          </Menu.Item>
          <Menu.Item key="2" icon={<VideoCameraOutlined />} disabled>
            Videos
          </Menu.Item>
          <Menu.Item key="3" icon={<BarChartOutlined />} disabled>
            Estadísticas
          </Menu.Item>
          <Menu.Item key="4" icon={<CloudOutlined />} disabled>
            Pide online
          </Menu.Item>
          <Menu.Item key="5" icon={<AppstoreOutlined />} disabled>
            Servicios
          </Menu.Item>
          <Menu.Item key="6" icon={<TeamOutlined />} disabled>
            Asesores
          </Menu.Item>
          <Menu.Item key="7" icon={<ShopOutlined />}>
            Inicio
          </Menu.Item>
        </Menu>
      </Sider>
      <Header style={{ padding: 0, position: "fixed", zIndex: 1, width: "100%" }}>
        <Row align="middle">
          <Row align="middle" justify="center" style={{ width: 80 }}>
            <img src={StarNo} alt="logo" style={{ height: 40 }} />
          </Row>

          <Title level={3} style={{ margin: "0 20px 7px 0", color: textColor }}>
            Tanluu
          </Title>

          <Text style={{ color: textColor }}>Novedades para la buena vida</Text>
        </Row>
      </Header>
      <Content
        style={{
          marginTop,
          marginLeft,
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <Row gutter={[16, 16]} align="middle" justify="center" style={{ height: "100%" }}>
          <Col>
            <Row justify="center">
              <img src={Star} className="App-logo" alt="logo" />
            </Row>

            <Row justify="center">
              <Title level={1} style={{ color: textColor }}>
                Bienvenidos a mi sitio
              </Title>
            </Row>

            <Row justify="center">
              <Tag onClick={() => window.open("http://google.com.pe", "_blank", "noopener,noreferrer")} style={{ cursor: "pointer" }} icon={<SendOutlined />} color="#5570ff">
                Telegram
              </Tag>
              <Tag onClick={() => window.open("http://google.com.pe", "_blank", "noopener,noreferrer")} style={{ cursor: "pointer" }} icon={<YoutubeOutlined />} color="#cd201f">
                Youtube
              </Tag>
              <Tag onClick={() => window.open("http://google.com.pe", "_blank", "noopener,noreferrer")} style={{ cursor: "pointer" }} icon={<FacebookOutlined />} color="#3b5999">
                Facebook
              </Tag>
              <Tag onClick={() => window.open("http://google.com.pe", "_blank", "noopener,noreferrer")} style={{ cursor: "pointer" }} icon={<InstagramOutlined />} color="#ee3040">
                Instagram
              </Tag>
            </Row>

            <br />

            <Row justify="center">
              <Carousel autoplay style={{ width: "450px" }}>
                <div>
                  <Image width="100%" style={contentStyle} src="https://oceandrive.com.ve/wp-content/uploads/2019/06/paso-a-paso-pizza-casa-.jpg" fallback={tipos.noImage} />
                </div>
                <div>
                  <Image width="100%" style={contentStyle} src="https://www.recetasdesbieta.com/wp-content/uploads/2018/10/lasagna-original..jpg" fallback={tipos.noImage} />
                </div>
                <div>
                  <Image width="100%" style={contentStyle} src="https://coctelia.com/wp-content/uploads/2020/10/cafe-dalgona.jpg" fallback={tipos.noImage} />
                </div>
                <div>
                  <Image
                    width="100%"
                    style={contentStyle}
                    src="https://badun.nestle.es/imgserver/v1/80/1290x742/8daf0b9f8ddc-cinnamon-rolls-de-chocolate-blanco.jpg"
                    fallback={tipos.noImage}
                  />
                </div>
                <div>
                  <Image
                    width="100%"
                    style={contentStyle}
                    src="https://scontent.flim15-1.fna.fbcdn.net/v/t1.6435-9/111145351_119754496482115_2191884839813901835_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=8bfeb9&_nc_eui2=AeH3n82bxcxPdcnu-J4os_yEvKVipabAzbW8pWKlpsDNtdsdFvscLcZ4AtZFH6SHt_M&_nc_ohc=MhoXNbW82vAAX9hRdFn&_nc_ht=scontent.flim15-1.fna&oh=f5a8e9fe19730ce191f70afa7f917972&oe=61B01053"
                    fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                  />
                </div>
              </Carousel>
            </Row>

            <br />

            <Row justify="space-between">
              <Statistic title="Personas a las que les gusta" value={1128} valueStyle={{ color: "inherit" }} prefix={<LikeOutlined />} />
              <Statistic title="Pedidos realizados al momento" value={93} valueStyle={{ color: "inherit" }} suffix={<span>&nbsp;/ 1000</span>} />
            </Row>

            <br />

            <Row justify="center">
              <Col>
                <Statistic title="Porcentaje de buena racha" value={100} precision={2} valueStyle={{ color: "#3f8600" }} suffix="%" />
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
      <footer
        style={{
          bottom: 0,
          height: marginBottom,
          marginLeft,
          width: "100%",
          position: "fixed",
          backgroundColor: "#353535",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span>Diseño ©2021 Created by Nox</span>
        </div>
      </footer>

      <div
        className={animFace ? "animate__animated animate__bounce" : ""}
        onMouseEnter={() => {
          if (window.innerWidth > 500) {
            setAnimFace(true);
            setTimeout(() => {
              setAnimFace(false);
            }, 1000);
          }
        }}
        onClick={() => {
          window.open(
            "https://api.whatsapp.com/send?phone=51999999999&text=Hola!+Dueño.+me+gustar%C3%ADa+saber+m%C3%A1s+de+tus+productos.+%F0%9F%98%8A",
            "_blank",
            "noopener,noreferrer"
          );
        }}
        style={{
          zIndex: 1,
          width: 60,
          height: 60,
          right: 0 + 10,
          display: "flex",
          borderRadius: 28,
          cursor: "pointer",
          position: "absolute",
          alignItems: "center",
          justifyContent: "center",
          bottom: 0 + marginBottom + 10,
          // backgroundColor: "#1088e9",
        }}
      >
        <img alt="wsp" src={Wsp} style={{ height: 50 }} />
      </div>
    </Layout>
  );
};
